const Buffer = require('buffer/').Buffer
/**
 * Утилиты связанные с URL
 */
export const bURL = {
    /**
     * Сохраняет переменные в BASE64 URI компонент
     * @param data
     */
    saveVariablesToURIComponent<T>(data: T): string {
        const s = JSON.stringify(data);
        // return encodeURIComponent(new Buffer(s, 'utf8').toString('base64')
        return encodeURI(Buffer.from(s).toString('base64').replace(/=/g,''));
    },

    /**
     * Извлекает переменные из BASE64 URI компонента
     * @param res
     */
    getVariablesFromURIComponent<T>(res?: string | null): Partial<T> {
        if (res) {
            try {
                const decoded = decodeURI(res);
                const sources = Buffer.from(decoded, 'base64').toString('utf8').split('}')[0] + '}';
                return JSON.parse(sources)
            } catch (e) {
                console.warn('[Error payload: getVariablesFromURIComponent:res]', res);
                console.error(e);
            }
        }

        return {}
    },
};
const Buffer = require('buffer/').Buffer
/**
 * Утилиты связанные с URL
 */
export const bURL = {
    /**
     * Сохраняет переменные в BASE64 URI компонент
     * @param data
     */
    saveVariablesToURIComponent<T>(data: T): string {
        const s = JSON.stringify(data);
        // return encodeURIComponent(new Buffer(s, 'utf8').toString('base64')
        return encodeURI(Buffer.from(s).toString('base64').replace(/=/g,''));
    },

    /**
     * Извлекает переменные из BASE64 URI компонента
     * @param res
     */
    getVariablesFromURIComponent<T>(res?: string | null): Partial<T> {
        if (res) {
            try {
                const decoded = decodeURI(res);
                const sources = Buffer.from(decoded, 'base64').toString('utf8').split('}')[0] + '}';
                return JSON.parse(sources)
            } catch (e) {
                console.warn('[Error payload: getVariablesFromURIComponent:res]', res);
                console.error(e);
            }
        }

        return {}
    },
};
